module.exports = __webpack_public_path__ + "static/media/bills_of_landing_active.a9491d4c.svg";